import Expandable from './expandable';
import { onReady } from './utils.js';

onReady( function() {
	const acordeonContainer = document.querySelector( '.c-acordeon' );
	if ( ! acordeonContainer ) {
		return;
	}

	Expandable( acordeonContainer );
} );
